import React, { useState, useEffect } from "react";
import { BrowserRouter, useLocation, Routes, Route } from "react-router-dom";
import "./App.css";
import { Foot, Head, TopNavBar, SidebarNav } from "./components";
import { LoginNavs, LogoutNavs } from "./navs";
import { useUserContext, Datafetcher } from "./context";
import { Errorhai } from "./components";
import ScrollToTop from "./components/ScrollToTop";

const AppContent = () => {
  const { isloggedin } = useUserContext();
  const [isCollapsed, setCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1024);
      if (window.innerWidth >= 1024) {
        setIsMobileMenuOpen(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isAppRoute = location.pathname.startsWith("/app");

  return (
    <div className="min-h-screen flex flex-col">
      {isloggedin ? (
        <div className="flex flex-row flex-grow">
          {!isAppRoute && (
            <SidebarNav
              isCollapsed={isCollapsed}
              setCollapsed={setCollapsed}
              isMobileView={isMobileView}
              isMobileMenuOpen={isMobileMenuOpen}
              setIsMobileMenuOpen={setIsMobileMenuOpen}
            />
          )}

          {isMobileView && isMobileMenuOpen && (
            <div
              onClick={closeMobileMenu}
              className="fixed inset-0 bg-black opacity-50 z-30 lg:hidden"
            ></div>
          )}

          <Datafetcher />

          <div className="flex flex-col w-full overflow-y-auto transition-all">
            {!isAppRoute && (
              <TopNavBar
                isMobileView={isMobileView}
                isMobileMenuOpen={isMobileMenuOpen}
                setIsMobileMenuOpen={setIsMobileMenuOpen}
              />
            )}

            <LoginNavs />
          </div>
        </div>
      ) : (
        <LogoutNavs />
      )}
      <Errorhai />
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
};

export default App;
